import {Box, Typography} from '@mui/material';
import ArrDataGridPro from '../../common/arr-data-grid-pro/ArrDataGridPro';
import {ReactComponent as NoDataIcon} from '../../../assets/images/no-data-found.svg';
import {t} from 'i18next';
import {columns} from './IndexManagementData';
import './IndexManagementData.scss';
import ArrMenu, {CustomMenuItem} from '../../common/arr-menu/ArrMenu';
import {IndexManagementType} from './IndexManagementTypeData';
import ArrModal from '../../common/arr-modal/ArrModal';
import {useMemo} from 'react';
import ArrToastNotification from '../../common/arr-toast-notification/ArrToastNotification';
import {UseIndexManagement} from './IndexManagementController';

export const rows: IndexManagementType[] = [
  {
    id: 1,
    indexName: 'Custom Index 1',
    securityGroup: 'security_group',
    status: 'Draft',
    docCount: 100000,
    indexSize: 'full',
    fieldCount: 40,
    createDate: '2001/07/01',
    lastIndexDate: '2001/08/01',
    userCreated: 'lastname_firstname',
    userLastIndex: 'lastname_firstname',
  },
  {
    id: 2,
    indexName: 'Custom Index 2',
    securityGroup: 'security_group',
    status: 'Complete',
    docCount: 100000,
    indexSize: 'full',
    fieldCount: 40,
    createDate: '2001/01/01',
    lastIndexDate: '2001/02/01',
    userCreated: 'lastname_firstname',
    userLastIndex: 'lastname_firstname',
  },
  {
    id: 3,
    indexName: 'Custom Index 3',
    securityGroup: 'security_group',
    status: 'Failed',
    docCount: 100000,
    indexSize: 'full',
    fieldCount: 40,
    createDate: '2001/03/01',
    lastIndexDate: '2001/04/01',
    userCreated: 'lastname_firstname',
    userLastIndex: 'lastname_firstname',
  },
  {
    id: 4,
    indexName: 'Custom Index 4',
    securityGroup: 'security_group',
    status: 'Complete',
    docCount: 100000,
    indexSize: 'full',
    fieldCount: 40,
    createDate: '2001/05/01',
    lastIndexDate: '2001/06/01',
    userCreated: 'lastname_firstname',
    userLastIndex: 'lastname_firstname',
  },
  {
    id: 5,
    indexName: 'Custom Index 5',
    securityGroup: 'security_group',
    status: 'Complete',
    docCount: 100000,
    indexSize: 'full',
    fieldCount: 40,
    createDate: '2001/05/01',
    lastIndexDate: '2001/06/01',
    userCreated: 'lastname_firstname',
    userLastIndex: 'lastname_firstname',
  },
  {
    id: 6,
    indexName: 'Custom Index 6',
    securityGroup: 'security_group',
    status: 'Complete',
    docCount: 100000,
    indexSize: 'full',
    fieldCount: 40,
    createDate: '2001/05/01',
    lastIndexDate: '2001/06/01',
    userCreated: 'lastname_firstname',
    userLastIndex: 'lastname_firstname',
  },
  {
    id: 7,
    indexName: 'Custom Index 7',
    securityGroup: 'security_group',
    status: 'Complete',
    docCount: 100000,
    indexSize: 'full',
    fieldCount: 40,
    createDate: '2001/05/01',
    lastIndexDate: '2001/06/01',
    userCreated: 'lastname_firstname',
    userLastIndex: 'lastname_firstname',
  },
  {
    id: 8,
    indexName: 'Custom Index 8',
    securityGroup: 'security_group',
    status: 'Complete',
    docCount: 100000,
    indexSize: 'full',
    fieldCount: 40,
    createDate: '2001/05/01',
    lastIndexDate: '2001/06/01',
    userCreated: 'lastname_firstname',
    userLastIndex: 'lastname_firstname',
  },
  {
    id: 9,
    indexName: 'Custom Index 9',
    securityGroup: 'security_group',
    status: 'Complete',
    docCount: 100000,
    indexSize: 'full',
    fieldCount: 40,
    createDate: '2001/05/01',
    lastIndexDate: '2001/06/01',
    userCreated: 'lastname_firstname',
    userLastIndex: 'lastname_firstname',
  },
  {
    id: 10,
    indexName: 'Custom Index 10',
    securityGroup: 'security_group',
    status: 'Complete',
    docCount: 100000,
    indexSize: 'full',
    fieldCount: 40,
    createDate: '2001/05/01',
    lastIndexDate: '2001/06/01',
    userCreated: 'lastname_firstname',
    userLastIndex: 'lastname_firstname',
  },
  {
    id: 11,
    indexName: 'pined row data',
    securityGroup: 'security_group',
    status: 'Complete',
    docCount: 100000,
    indexSize: 'full',
    fieldCount: 40,
    createDate: '2001/05/01',
    lastIndexDate: '2001/06/01',
    userCreated: 'lastname_firstname',
    userLastIndex: 'lastname_firstname',
  },
];

export const pinnedRows = {
  top: [
    {
      id: 12,
      indexName: 'Standard Index1',
      securityGroup: 'security_group',
      status: 'Complete',
      docCount: 100000,
      indexSize: 'full',
      fieldCount: 40,
      createDate: '2001/05/01',
      lastIndexDate: '2001/06/01',
      userCreated: 'lastname_firstname',
      userLastIndex: 'lastname_firstname',
    },
    {
      id: 13,
      indexName: 'Standard Index2',
      securityGroup: 'security_group',
      status: 'Complete',
      docCount: 100000,
      indexSize: 'full',
      fieldCount: 40,
      createDate: '2001/05/01',
      lastIndexDate: '2001/06/01',
      userCreated: 'lastname_firstname',
      userLastIndex: 'lastname_firstname',
    },
  ],
};

const PAGE_SIZE_OPTIONS = [25, 50, 100];
const IndexManagement = () => {
  const {
    filterModel,
    setFilterModel,
    handleSortModelChange,
    sortModel,
    handleMoreIconClick,
    pageNumber,
    pageSize,
    setPageNumber,
    setPageSize,
    actionMenuRef,
    onMenuItemClick,
    isDeleteCustomIndex,
    setIsDeleteCustomIndex,
    rebuildModalOpen,
    setRebuildModalOpen,
    clickedMenuRow,
    showToast,
    setShowToast,
    toastMessage,
    toastStatus,
    handleDeleteIndex,
    actionMenuItem,
  } = UseIndexManagement();

  const filteredActions = useMemo((): CustomMenuItem[] => {
    const status = clickedMenuRow?.status ?? '';
    const name = clickedMenuRow?.indexName;
    const disabledMap: Record<string, boolean> = {
      view: false,
      rebuildIndex: !['Complete', 'Failed'].includes(status),
      deleteIndex: !['Complete', 'Failed'].includes(status),
    };

    const mapAndFilter = (items: CustomMenuItem[]): CustomMenuItem[] =>
      items?.map((it) => ({
        id: String(it.id),
        label: it.label,
        disabled: disabledMap[it.id] ?? false,
        variant:
          it.id === 'deleteIndex' && ['Complete', 'Failed'].includes(status)
            ? 'danger'
            : 'heading',
      }));
    const actionMenuData = name?.includes('Standard Index')
      ? actionMenuItem.filter((actionMenu) => actionMenu.id != 'deleteIndex' && actionMenu.id != 'rebuildIndex')
      : actionMenuItem;
    return mapAndFilter(actionMenuData);
  }, [clickedMenuRow]);

  const NoRowsOverlay = () => {
    if (pinnedRows.top?.length > 0) {
      return null;
    }
    return (
      <Box className="no-grid-overlay">
        <NoDataIcon />
        <Typography
          className="typo-text headline3_size"
          data-testid="no-meta-result"
        >
          {t('ingestions.indexManagement.noQueryReturnDataMsg')}
        </Typography>
      </Box>
    );
  };
   const rebuildModalDescription =  (
          <>
            <Typography data-testid={`index-management-description1`}>{t('indexManagement.customIndex.rebuildModal.description1')}</Typography>
            <Typography data-testid={`index-management-typography`}>&nbsp;</Typography>
            <Typography data-testid={`index-management-description2`}>{t('indexManagement.customIndex.rebuildModal.description2')}</Typography>
          </>
        );

  return (
    <Box
      className="index-management-data-grid"
      data-testid="history-grid-wrapper"
    >
      <ArrDataGridPro
        rows={rows}
        columns={columns(handleMoreIconClick)}
        density="compact"
        disableVirtualization
        headerFilters
        showPerPageOptions
        pagination
        pageSizeOptions={PAGE_SIZE_OPTIONS}
        noRowsOverlay={NoRowsOverlay}
        itemsPerPage={pageSize}
        setItemsPerPage={setPageSize}
        onPageChange={setPageNumber}
        currentPage={pageNumber}
        disableColumnResize={false}
        rowCount={rows?.length + pinnedRows.top?.length}
        entityType={t('ingestions.indexManagement.entries')}
        hideFooter={rows?.length === 0 && pinnedRows.top.length === 0}
        filterModel={filterModel}
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        onFilterModelChange={setFilterModel}
        filterMode="server"
        paginationMode="server"
        pinnedRows={pageNumber === 1 ? pinnedRows : undefined}
      />
      <ArrMenu
        id="more-menu"
        ref={actionMenuRef}
        items={filteredActions}
        onItemClick={onMenuItemClick}
        direction="left"
      />
      {rebuildModalOpen && (
        <ArrModal
          showModal={rebuildModalOpen}
          showClose={false}
          onClose={() => {
            setRebuildModalOpen(false);
          }}
          title={t('indexManagement.customIndex.readOnly.rebuildIndex')}
          ariaLabel={t('indexManagement.customIndex.readOnly.rebuildIndex') + 'modal'}
          description={rebuildModalDescription}
          buttons={[
            {
              id: '1',
              label: t('common.cancel'),
              onClick: () => {
                setRebuildModalOpen(false);
              },
              variant: 'secondary',
              ariaLabel: t('common.cancel'),
              dataTestId: 'rebuild-modal-cancel',
              ariaDescribedBy: t('indexManagement.customIndex.rebuildModal.cancelBtnHint'),
            },
            {
              id: '2',
              label: t('indexManagement.customIndex.readOnly.rebuildIndex'),
              onClick: () => {
                setRebuildModalOpen(false);
              },
              variant: 'primary',
              dataTestId: 'rebuild-modal-confirm',
              ariaLabel: t('indexManagement.customIndex.readOnly.rebuildIndex'),
              ariaDescribedBy: t(
                                'indexManagement.customIndex.rebuildModal.rebuildBtnHint'
                              ),
            },
          ]}
        />
      )}
      {isDeleteCustomIndex && (
        <ArrModal
          showModal={isDeleteCustomIndex}
          showClose={false}
          onClose={() => {
            setIsDeleteCustomIndex(false);
          }}
          className="delete-custom-index-modal"
          title={t('ingestions.indexManagement.deleteCustomIndex.title')}
          description={t('ingestions.indexManagement.deleteCustomIndex.desc1', {
            indexName: clickedMenuRow?.indexName,
          })}
          dataTestId="delete-custom-index-modal"
          buttons={[
            {
              id: '1',
              label: t('common.cancel'),
              onClick: () => {
                setIsDeleteCustomIndex(false);
              },
              variant: 'secondary',
              dataTestId: 'dci-cancel-btn',
            },
            {
              id: '2',
              label: t(
                'ingestions.indexManagement.deleteCustomIndex.deleteIndex'
              ),
              onClick: () => handleDeleteIndex(),
              variant: 'danger',
              dataTestId: 'dci-delete-btn',
            },
          ]}
        >
          <Box className="custom-modal-body">
            <Typography
              className="typo-text body2_size desc-text-color"
              data-testid={`index-management-desc2`}>
              {t('ingestions.indexManagement.deleteCustomIndex.desc2')}
            </Typography>
          </Box>
        </ArrModal>
      )}
      {showToast && (
        <ArrToastNotification
          message={toastMessage}
          status={toastStatus}
          onClose={() => setShowToast(false)}
        />
      )}
    </Box>
  );
};

export default IndexManagement;
